import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { environment } from 'projects/foreign-admits/src/environments/environment';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerService } from '../services/partner.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';

@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss']
})
export class PersonalDetailsComponent implements OnInit {
  personalDetails: any = {};
  selectedSection: string = 'personal';
  partnerLogo: string = '';
  puid: string = "";
  isEditing: boolean = false;
  isLoading: boolean = false;
  private baseUrl: string = environment.apiBaseUrl;
  layoutPersonalInfo: FormlyFieldConfig[];
  userDetails: any;
  model: any = {};
  dataModel: string = 'users';
  saveChangesPersonal: boolean = false;
  courseFinderAvailableSpecializations = this.configService.getConfig("foreignAssist", "courseFinderAvailableSpecializations");
  admissionCountryOptions = this.configService.getConfig("foreignAssist", "admissionCountryOptions");
  courseFinderDegreeOptions = this.configService.getConfig("foreignAssist", "courseFinderDegreeOptions");
  gradingSystemOptions = this.configService.getConfig("foreignAssist", "gradingSystemOptions");
  private aptitudeTests = ['GRE', 'GMAT', 'SAT', 'ACT', 'gre', 'gmat', 'sat', 'act'];
  private languageTests = ['IELTS', 'TOEFL', 'PTE', 'DET', 'Duolingo', 'ielts', 'toefl', 'pte', 'det', 'duolingo'];

  constructor(
    private apiHelper: ApiHelperService,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private partnerService: PartnerService,
    private router: Router,
    private configService: ConfigService,
  ) { }


  ngOnInit(): void {
    console.info("hello", 32)
    this.getStudentDetails();

    this.puid = this.activatedRoute.snapshot.paramMap.get('puid') || '';
    if (this.puid) {
      this.fetchPartnerLogo(this.puid);
    }
    console.info(this.courseFinderAvailableSpecializations, 49)
    this.dataPreProcessor();
    // this.userDetails = this.studentDetails;
  }


  toggleEdit(): void {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      this.dataPreProcessor();
    }
  }

  dataProcessor(data: any): any {
    return data;
  }


  populateFormWithDetails(): void {
    this.model = { ...this.personalDetails };
    this.setLayout();
    this.cd.detectChanges();
  }


  onSubmit(event: any): void {
    console.log(" Form submitted with data:", event);

    if (event?.error) {
      console.error(' Form submission error:', event.error);
      return;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      console.error('No access token found');
      return;
    }

    const uid = localStorage.getItem('uid');
    if (!uid) {
      console.error(' UID not found.');
      return;
    }

    this.isLoading = true;

    const endpoint = `student-choices/update-student-details-uid/${uid}`;
    console.log("📡 Sending PATCH request to:", endpoint); // Debugging Log

    this.apiHelper.patchDataWithShortlistingUrl(endpoint, event)
      .then((response: any) => {
        console.log("API Response:", response);
        this.isLoading = false;

        if (response.success) {

          this.isEditing = false;
          console.log('Student details updated successfully');

          this.personalDetails = { ...response.data };

          this.getStudentDetails();
          this.cd.detectChanges();
          this.cd.markForCheck();
        } else {
          // this.isLoading = false;
          console.error(' Error updating student details:', response.message);
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        console.error(' API Error:', error);
      });
  }

  setLayout(): void {
    this.layoutPersonalInfo = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            template: '<h4>My Profile</h4>',
            className: 'col-12',
          },
          // Profile Card Fields
          {
            className: 'col-md-4',
            key: 'firstName',
            type: 'input',
            templateOptions: {
              label: 'First Name',
              placeholder: 'First Name',

            },
          },
          {
            className: 'col-md-4',
            key: 'lastName',
            type: 'input',
            templateOptions: {
              label: 'Last Name',
              placeholder: 'Last Name',
            },
          },
          {
            className: 'col-md-4',
            key: 'email',
            type: 'input',
            templateOptions: {
              label: 'Email',
              placeholder: 'Email',
              type: 'email',
            },
          },
          {
            className: 'col-md-4',
            key: 'targetCountry',
            type: 'select',
            templateOptions: {
              label: "Country",
              required: true,
              options: this.admissionCountryOptions,
              placeholder: "Select Country"
            }
          },
          {
            className: 'col-md-4',
            key: 'targetDegree',
            type: 'select',
            templateOptions: {
              label: "Degree",
              required: true,
              options: this.courseFinderDegreeOptions,
              placeholder: "Select Degree"
            }
          },
          {
            className: 'col-md-4',
            key: 'targetCourse',
            type: 'select',
            templateOptions: {
              label: "Course",
              required: true,
              options: this.courseFinderAvailableSpecializations,
              placeholder: "Select Course"
            }
          },
        ],
      },
      // Under Graduation Score Section
      {
        fieldGroupClassName: 'row mt-4',
        hideExpression: "model.personalDetails?.academicHistory?.undergraduateMarks?.percentage === null",
        fieldGroup: [
          {
            template: '<h4>Under Graduation Score</h4>',
            className: 'col-12',
          },
          {
            className: 'col-md-3',
            key: 'academicHistory.undergraduateMarks.undergradCollegeName',
            type: 'input',
            templateOptions: {
              label: 'College Name',
              placeholder: 'College Name',
            },
          },
          {
            className: 'col-md-3',
            key: 'academicHistory.undergraduateMarks.scoreSystem',
            type: 'select',
            templateOptions: {
              label: 'Grading system & Marks scored*',
              options: this.gradingSystemOptions,
              placeholder: 'Select'
            }
          },
          // Aggregate Marks Input
          {
            className: 'col-md-3',
            key: 'academicHistory.undergraduateMarks.score',
            type: 'input',
            templateOptions: {
              label: 'Aggregate Marks',
              placeholder: 'Enter aggregate marks from all semesters',
              type: 'number',
            },
          },
          {
            className: 'col-md-3',
            key: 'academicHistory.undergraduateMarks.degreeBacklogs',
            type: 'input',
            templateOptions: {
              label: 'No. of Backlogs',
              placeholder: 'Backlogs',
            },
          },
        ],
      },

      //high school score
      {
        fieldGroupClassName: 'row mt-4',
        hideExpression: "model.personalDetails?.academicHistory?.undergraduateMarks?.percentage != null",
        fieldGroup: [
          {
            template: '<h4>High School Score</h4>',
            className: 'col-12',
          },
          {
            className: 'col-md-4',
            key: 'academicHistory.highSchoolMarks.highSchoolName',
            type: 'input',
            templateOptions: {
              label: 'College Name',
              placeholder: 'College Name',
            },
          },
          {
            className: 'col-md-4',
            key: 'academicHistory.highSchoolMarks.highSchoolScoreSystem',
            type: 'select',
            templateOptions: {
              label: 'Grading system & Marks scored*',
              options: this.gradingSystemOptions,
              placeholder: 'Select'
            }
          },
          // Aggregate Marks Input
          {
            className: 'col-md-4',
            key: 'academicHistory.highSchoolMarks.highSchoolScore',
            type: 'input',
            templateOptions: {
              label: 'Aggregate Marks',
              placeholder: 'Enter aggregate marks from all semesters',
              type: 'number',
            },
          },
        ],
      },
      // Test Scores Section
      {
        fieldGroupClassName: 'row mt-4',
        fieldGroup: [
          {
            template: '<h4>Test Scores</h4>',
            className: 'col-12',
          },
          // Simple aptitude test fields
          {
            className: 'col-md-6',
            key: 'entryTests[0].testName',
            type: 'select',
            templateOptions: {
              label: 'Aptitude Test Name *',
              options: [
                { label: 'GRE', value: 'gre' },
                { label: 'GMAT', value: 'gmat' },
                { label: 'SAT', value: 'sat' },
                { label: 'ACT', value: 'act' },
                { label: 'Not Taken Yet', value: 'not_taken' }
              ]
            }
          },
          {
            className: 'col-md-6',
            key: 'entryTests[0].testScore',
            type: 'input',
            templateOptions: {
              label: 'Aptitude Test Score *',
              placeholder: 'Aptitude Test Score',
              type: 'number',
            },
            hideExpression: 'model.entryTests[0].testName === "not_taken"',
            expressionProperties: {
              // Set min/max dynamically based on test type
              'templateOptions.min': (model) => {
                switch (model.entryTests?.[0]?.testName) {
                  case 'gre': return 260;
                  case 'gmat': return 200;
                  case 'sat': return 400;
                  case 'act': return 1;
                }
              },
              'templateOptions.max': (model) => {
                switch (model.entryTests?.[0]?.testName) {
                  case 'gre': return 340;
                  case 'gmat': return 800;
                  case 'sat': return 1600;
                  case 'act': return 36;
                }
              }
            },
            validation: {
              messages: {
                min: (error, field) => {
                  const testType = field.model.entryTests?.[0]?.testName?.toUpperCase() || 'selected test';
                  const minValue = field.templateOptions.min;
                  return `${testType} score must be at least ${minValue}`;
                },
                max: (error, field) => {
                  const testType = field.model.entryTests?.[0]?.testName?.toUpperCase() || 'selected test';
                  const maxValue = field.templateOptions.max;
                  return `${testType} score cannot exceed ${maxValue}`;
                }
              }
            }
          },
          {
            className: 'col-md-6',
            key: 'entryTests[1].testName',
            type: 'select',
            templateOptions: {
              label: 'Language Test Name *',
              options: [
                { label: 'IELTS', value: 'ielts' },
                { label: 'TOEFL', value: 'toefl' },
                { label: 'PTE', value: 'pte' },
                { label: 'DET', value: 'det' },
                { label: 'Not Taken Yet', value: 'not_taken' }
              ]
            }
          },
          {
            className: 'col-md-6',
            key: 'entryTests[1].testScore',
            type: 'input',
            templateOptions: {
              label: 'Language Test Score *',
              placeholder: 'Language Test Score',
              type: 'number',
            },
            hideExpression: 'model.entryTests[1].testName === "not_taken"',
            expressionProperties: {
              // Set min/max dynamically based on test type
              'templateOptions.min': (model) => {
                switch (model.entryTests?.[1]?.testName) {
                  case 'ielts': return 0;
                  case 'toefl': return 0;
                  case 'pte': return 10;
                  case 'det': return 10;
                }
              },
              'templateOptions.max': (model) => {
                switch (model.entryTests?.[1]?.testName) {
                  case 'ielts': return 9;
                  case 'toefl': return 120;
                  case 'pte': return 90;
                  case 'det': return 160;
                }
              },
              'templateOptions.step': (model) => {
                // For IELTS, allow 0.5 increments
                return model.entryTests?.[1]?.testName === 'ielts' ? 0.5 : 1;
              }
            },

            validation: {
              messages: {
                min: (error, field) => {
                  const testType = field.model.entryTests?.[1]?.testName?.toUpperCase() || 'selected test';
                  const minValue = field.templateOptions.min;
                  return `${testType} score must be at least ${minValue}`;
                },
                max: (error, field) => {
                  const testType = field.model.entryTests?.[1]?.testName?.toUpperCase() || 'selected test';
                  const maxValue = field.templateOptions.max;
                  return `${testType} score cannot exceed ${maxValue}`;
                }
              }
            }
          },
        ],
      },
      // Work Experience Section
      {
        fieldGroupClassName: 'row mt-4',
        fieldGroup: [
          {
            template: '<h4>Work Experience</h4>',
            className: 'col-12',
          },
          {
            className: 'col-md-6',
            key: 'months_of_experience',
            type: 'input',
            templateOptions: {
              label: 'Months of Experience',
              placeholder: 'Enter experience in months',
            },
          },
        ],
      },
      // Footer Buttons
      {
        fieldGroupClassName: 'fixed-bottom-button-container d-flex justify-content-center align-items-center gap-3 mb-5',
        fieldGroup: [
          {
            fieldGroupClassName: 'd-flex gap-3 mb-4',
            fieldGroup: [
              {
                type: 'button',
                templateOptions: {
                  btnType: 'primary px-2',
                  type: 'submit',
                  text: 'Save Changes',
                },
              },
              {
                type: 'button',
                templateOptions: {
                  btnType: 'secondary  px-3 py-1.5', // Use "secondary" for cancel
                  type: 'button', // Corrected from 'camcel' to 'button'
                  text: 'Cancel',
                  onClick: () => this.onCancel(),
                },
              },
            ],
          },
        ],
      }
    ];
  }

  fetchPartnerLogo(puid?: string): void {
    this.partnerService.getPartnerLogo(puid).then(
      (response) => {
        if (response?.data?.company?.logo) {
          this.partnerLogo = response.data.company.logo;
          console.info("Fetched Partner Logo URL:", this.partnerLogo);
        } else {
          console.warn("No partner logo found for PUID:", puid);
        }
      },
      (error) => {
        console.error('Error fetching partner logo:', error);
      }
    );
  }

  openEditSection(key?: string): void {
    if (key === 'saveChangesPersonal') {
      this.saveChangesPersonal = true;
    } else {
      this.isEditing = true;
    }

    this.dataPreProcessor();
    this.setLayout();
  }


getStudentDetails(): void {
  const uid = localStorage.getItem('uid');
  const puid = this.activatedRoute.snapshot.paramMap.get('puid');

  if (!uid || !puid) {
    console.error('UID or PUID not found.');
    return;
  }

  let endpoint = `student-choices/get-student-details/${uid}`;
  if (puid) {
    endpoint += `/${puid}`;
  } else {
    endpoint += '/null';
  }

  console.log("🔵 Fetching latest student details from:", endpoint);

  this.apiHelper.getDataWithShortlistingUrl(endpoint)
    .then((response: any) => {
      if (response.success) {
        console.log("✅ Fetched updated student details:", response.data);

        this.personalDetails = { ...response.data };
        
        // *** ADD THIS LINE - reorganize entryTests after fetching data ***
        this.reorganizeEntryTests();
        
        this.cd.detectChanges();
        console.log('Student Details fetched:', this.personalDetails);

        this.populateFormWithDetails();
      } else {
        console.error('Error fetching student details:', response.message);
      }
    })
    .catch((error: any) => {
      console.error('Error fetching student details:', error);
    });
}




dataPreProcessor(): void {
  const defaultModel = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    targetCountry: '',
    targetDegree: '',
    targetCourse: '',
    academicHistory: {
      undergraduateMarks: { percentage: 'Not Available', degreeBacklogs: '0' },
      highSchoolMarks: { highSchoolName: 'N/A' }
    },
    entryTests: [],
    months_of_experience: null
  };

  // Merge API data into the default structure
  this.personalDetails = { ...defaultModel, ...this.personalDetails };

  // Handle missing nested properties
  this.personalDetails.academicHistory = { ...defaultModel.academicHistory, ...this.personalDetails.academicHistory };

  this.personalDetails.entryTests = this.personalDetails.entryTests || [];

  // *** ADD THIS LINE ONLY - everything else stays the same ***
  this.reorganizeEntryTests();

  this.cd.detectChanges(); // Trigger UI update
}

  private reorganizeEntryTests(): void {
  if (!this.personalDetails?.entryTests || this.personalDetails.entryTests.length === 0) {
    // Create empty structure if no tests exist
    this.personalDetails.entryTests = [
      { testName: null, testScore: null }, // Index 0 for aptitude
      { testName: null, testScore: null }  // Index 1 for language
    ];
    return;
  }

  const originalTests = [...this.personalDetails.entryTests];
  
  // Find aptitude and language tests from the original array
  const aptitudeTest = originalTests.find(test => 
    this.aptitudeTests.includes(test.testName) || test.testName === 'Not Taken Yet'
  );
  
  const languageTest = originalTests.find(test => 
    this.languageTests.includes(test.testName)
  );

  // Create new organized array
  this.personalDetails.entryTests = [
    // Index 0: Aptitude test (what HTML expects for aptitude)
    aptitudeTest || { testName: null, testScore: null },
    
    // Index 1: Language test (what HTML expects for language)  
    languageTest || { testName: null, testScore: null }
  ];

  console.log('Reorganized entryTests:', this.personalDetails.entryTests);
}


  viewResults() {
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {
      this.router.navigate(['/results/' + puid]);
    }
    else {
      this.router.navigate(['/results']);
    }
  }


  onCancel(): void {
    console.log("Cancel button clicked");
    this.isEditing = false;
    this.getStudentDetails();
  }

  logout(): void {
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    localStorage.removeItem('token');
    localStorage.removeItem('uid');
    localStorage.removeItem('results');
    localStorage.removeItem('appliedFilters');
    localStorage.removeItem('currentFilter');
    localStorage.clear();

    if (puid) {
      this.router.navigate(['/student-login/' + puid]);
    }
    else {
      this.router.navigate(['/student-login']);
    }
  }


}
